import { createFileRoute } from '@tanstack/react-router';

import { TimeoffAuditReportPage } from '../modules/ComponentsLibrary/Reports/pages/TimeoffAuditReport/components/TimeoffAuditReportPage';

export const Route = createFileRoute('/reports/timeoff-audit')({
  component: TimeoffAuditReportPage,
});
